// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0b923b80","239":"c4b327ba","488":"d08351e5","667":"7d4851dc"}[chunkId] + ".chunk.js";
};